import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { SocialProofBar } from './components/SocialProofBar';
import { HeroSection } from './components/HeroSection';
import { Footer } from './components/Footer';
import { ThankYou } from './pages/ThankYou';
import { initFBPixel, trackPageView } from './utils/fbPixel';
function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView();
  }, [location.pathname]);
  return null;
}
function LandingPage() {
  return <div className="min-h-screen bg-dark-primary font-sans text-slate-300 selection:bg-omni/30 selection:text-white flex flex-col" data-id="element-0">
      <SocialProofBar data-id="element-1" />
      <main className="flex-1" data-id="element-2">
        <HeroSection data-id="element-3" />
      </main>
      <Footer data-id="element-4" />
    </div>;
}
export function App() {
  useEffect(() => {
    initFBPixel();
  }, []);
  return <BrowserRouter data-id="element-5">
      <PageViewTracker data-id="element-6" />
      <Routes data-id="element-7">
        <Route path="/" element={<LandingPage data-id="element-9" />} data-id="element-8" />
        <Route path="/thank-you" element={<ThankYou data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}